import React, {useTransition} from 'react';
import {CancelButton, Card, FlexBox, SaveButton} from 'components';
import {DataFormV1} from 'schema';
import {interceptPrizeSetFieldValue} from 'scenes/prizeEdit/functions/interceptPrizeSetFieldValue';
import type {EditPrizeProps} from '../types';
import {DeleteButtonV2} from '../../../components/button/DeleteButtonV2';
import {useEditPrizeState, usePrizeTitle} from '../hooks';
import {usePrizeFormConfiguration} from '../hooks/usePrizeFormConfiguration';
import {PrizeTitle} from './PrizeTitle';

export const EditPrize: React.FC<EditPrizeProps> = props => {
  const {mode, originalValue} = props;
  const title = usePrizeTitle(mode, originalValue);
  const prizeFormConfiguration = usePrizeFormConfiguration();

  const [isPending, startTransition] = useTransition();

  const {
    schema,
    initialEditPrize,
    hasChanges,
    showErrors,
    onChanged,
    savePrize,
    deletePrize,
  } = useEditPrizeState(props);

  return (
    <FlexBox gap={2} maxWidth={1600}>
      <FlexBox horizontal spaceBetween>
        <PrizeTitle title={title} />
        <FlexBox horizontal gap={2}>
          {deletePrize ? (
            <DeleteButtonV2
              disabled={isPending}
              onClick={() => {
                startTransition(async () => {
                  await deletePrize();
                });
              }}
            />
          ) : null}
          {hasChanges ? (
            <>
              <CancelButton onClick={props.onCancel} />
              <SaveButton
                disabled={isPending}
                onClick={() => {
                  startTransition(async () => {
                    await savePrize();
                  });
                }}
              />
            </>
          ) : null}
        </FlexBox>
      </FlexBox>
      <Card>
        <Card.Content>
          <DataFormV1
            key={'edit-prize'}
            id={'edit-prize'}
            schema={schema}
            data={initialEditPrize}
            relatedData={{}}
            mode={'edit'}
            showErrors={showErrors}
            configuration={prizeFormConfiguration}
            onDataChanged={onChanged}
            setFieldValueModifier={interceptPrizeSetFieldValue}
          />
        </Card.Content>
      </Card>
    </FlexBox>
  );
};
